import(/* webpackMode: "eager" */ "/vercel/path0/src/app/music/music.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/music/MusicClientComponent.tsx");
